import React from 'react'
import { LayoutBand, Image, Separator, Paragraph, H2, Subheading } from '@fs/zion-ui'

const roundedImageStyle = { borderRadius: '50%', width: '200px', height: '200px' }

export default function PromisedBlessings({ image, heading, subHeading, quotes }) {
  return (
    <LayoutBand maxWidth="xs">
      <Separator size="md" />
      <Image alt={heading} src={image} style={roundedImageStyle} />
      <Separator size="md" />
      {heading && (
        <>
          <H2 size="H5">
            {heading}
            <Subheading>{subHeading}</Subheading>
          </H2>
          <Separator size="md" />
        </>
      )}
      {quotes?.map((quote) => (
        <Paragraph key={quote} size="sm">
          {quote}
        </Paragraph>
      ))}
      <Separator size="xxl" />
    </LayoutBand>
  )
}
